import { base } from './';
import { CreateRoleType, IRole, RoleScope, UpdateRoleType } from 'types';

const scopePath = (scope: RoleScope) => `/org/${scope}/roles`;

const getAll = (scope: RoleScope) => base.get<IRole[]>(scopePath(scope));

// 전 조직 role
const getAllScopes = () => base.get<IRole[]>('/platform/roles/all');

const get = (scope: RoleScope, id: number) =>
  base.get<IRole>(`${scopePath(scope)}/${id}`);

const post = (scope: RoleScope, data: CreateRoleType) =>
  base.post<IRole>(scopePath(scope), data);

const put = (scope: RoleScope, id: number, data: UpdateRoleType) =>
  base.patch(`${scopePath(scope)}/${id}`, data);

const del = (scope: RoleScope, id: number) =>
  base.delete(`${scopePath(scope)}/${id}`);

export { getAll, getAllScopes, get, post, put, del };
